module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "residents"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black is-size-4"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Selected Residents at Progressbar Family Office")]), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Crypto Startups")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, _vm._l((_vm.residents.slice(0, 4)), function(r) {
    return _c('div', {
      staticClass: "column"
    }, [_c('a', {
      attrs: {
        "href": r.url
      }
    }, [_c('img', {
      attrs: {
        "src": ("/static/img/residents/" + (r.src)),
        "loading": "lazy",
        "alt": r.name
      }
    }), _c('br'), _vm._v(_vm._s(r.name))]), _vm._v(" "), _c('br'), _c('span', {
      domProps: {
        "innerHTML": _vm._s(r.desc)
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, _vm._l((_vm.residents.slice(4, 8)), function(r) {
    return _c('div', {
      staticClass: "column"
    }, [_c('a', {
      attrs: {
        "href": r.url
      }
    }, [_c('img', {
      attrs: {
        "src": ("/static/img/residents/" + (r.src)),
        "loading": "lazy",
        "alt": r.name
      }
    }), _c('br'), _vm._v(_vm._s(r.name))]), _vm._v(" "), _c('br'), _c('span', {
      domProps: {
        "innerHTML": _vm._s(r.desc)
      }
    })])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Exponential Technologies")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, _vm._l((_vm.exponentialResidents.slice(0, 4)), function(r) {
    return _c('div', {
      staticClass: "column"
    }, [_c('a', {
      attrs: {
        "href": r.url
      }
    }, [_c('img', {
      attrs: {
        "src": ("/static/img/residents/" + (r.src)),
        "loading": "lazy",
        "alt": r.name
      }
    }), _c('br'), _vm._v(_vm._s(r.name))]), _vm._v(" "), _c('br'), _c('span', {
      domProps: {
        "innerHTML": _vm._s(r.desc)
      }
    })])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Technology Meetups")]), _vm._v(" "), _c('div', {
    staticClass: "columns",
    attrs: {
      "id": "meetups"
    }
  }, _vm._l((_vm.meetups.slice(0, 4)), function(r) {
    return _c('div', {
      staticClass: "column is-3"
    }, [_c('a', {
      attrs: {
        "href": r.url
      }
    }, [_c('img', {
      attrs: {
        "src": ("/static/img/residents/" + (r.src)),
        "loading": "lazy",
        "alt": r.name
      }
    }), _c('br'), _vm._v(_vm._s(r.name))]), _vm._v(" "), _c('br'), _c('span', {
      domProps: {
        "innerHTML": _vm._s(r.desc)
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.meetups.slice(4, 8)), function(r) {
    return _c('div', {
      staticClass: "column is-3"
    }, [_c('a', {
      attrs: {
        "href": r.url
      }
    }, [_c('img', {
      attrs: {
        "src": ("/static/img/residents/" + (r.src)),
        "loading": "lazy",
        "alt": r.name
      }
    }), _c('br'), _vm._v(_vm._s(r.name))]), _vm._v(" "), _c('br'), _c('span', {
      domProps: {
        "innerHTML": _vm._s(r.desc)
      }
    })])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Social Impact")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, _vm._l((_vm.ngoResidents.slice(0, 3)), function(r) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('a', {
      attrs: {
        "href": r.url
      }
    }, [_c('img', {
      attrs: {
        "src": ("/static/img/residents/" + (r.src)),
        "loading": "lazy",
        "alt": r.name
      }
    }), _c('br'), _vm._v(_vm._s(r.name))]), _vm._v(" "), _c('br'), _c('span', {
      domProps: {
        "innerHTML": _vm._s(r.desc)
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, _vm._l((_vm.ngoResidents.slice(3, 7)), function(r) {
    return _c('div', {
      staticClass: "column is-3"
    }, [_c('a', {
      attrs: {
        "href": r.url
      }
    }, [_c('img', {
      attrs: {
        "src": ("/static/img/residents/" + (r.src)),
        "loading": "lazy",
        "alt": r.name
      }
    }), _c('br'), _vm._v(_vm._s(r.name))]), _vm._v(" "), _c('br'), _c('span', {
      domProps: {
        "innerHTML": _vm._s(r.desc)
      }
    })])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-12"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/eventspace/mlmu_december.jpg",
      "alt": "progressbar coworking bratislava blockchain"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f152f81c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Residents.vue
// module id = 261
// module chunks = 16